<template>
  <div class="page">
    <b-overlay
      :show="loading"
      variant="light"
      opacity="0.5"
      rounded="false"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <JurisdictionLayout
          :route-from="routeFrom"
          :mode="'edit'"
          @loading="$event => loading = $event"
          @cancel="
            currentOrganisation && currentOrganisation.id ?
              $router.push({
                name: 'OrganisationDetail',
                params: {
                  id: currentOrganisation.id
                }
              }) :
              { name: 'Organisations'}
          "
          @save="handleSubmit(updateJurisdiction)"
        />
      </ValidationObserver>
    </b-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { ErrorService } from '@/services/error-service.js';

import JurisdictionLayout from '@/app/jurisdiction/layouts/JurisdictionLayout.vue';

import { ValidationObserver } from 'vee-validate';

export default {
  name: 'JurisdictionDetail',

  components: {
    JurisdictionLayout,
    ValidationObserver
  },

  data() {
    return {
      loading: false,
      routeFrom: null
    };
  },

  computed: {
    ...mapState('organisations', [
      'currentOrganisation'
    ]),
    ...mapState('municipalities', [
      'municipalitiesList'
    ]),
    ...mapState('jurisdiction', [
      'currentJurisdiction',
      'jurisdictionsList'
    ])
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.routeFrom = from;
    });
  },

  async created() {
    try {
      this.loading = true;
      this.SET_CURRENT_JURIDICTION(null);
      this.RESET_SELECTED_MUNICIPALITIES();
      await this.GET_MUNICIPALITIES();
      if (this.jurisdictionsList.length === 0) {
        this.GET_JURISDICTIONS_LIST();
      }
      await this.GET_JURISDICTION(this.$route.params.id);
      if (this.municipalitiesList && this.municipalitiesList.length) {
        for (const insee of this.currentJurisdiction.municipalities) {
          const municipality = this.municipalitiesList.find(el => el.insee === insee);
          if (municipality) {
            this.SELECT_MUNICIPALITY(municipality);
          }
        }
      }
      this.loading = false;
    } catch {
      this.loading = false;
    }
  },

  methods: {
    ...mapMutations('jurisdiction', [
      'SET_CURRENT_JURIDICTION'
    ]),
    ...mapActions('jurisdiction', [
      'GET_JURISDICTIONS_LIST',
      'GET_JURISDICTION',
      'UPDATE_JURISDICTION'
    ]),
    ...mapMutations('municipalities', [
      'RESET_SELECTED_MUNICIPALITIES'
    ]),
    ...mapActions('municipalities', [
      'GET_MUNICIPALITIES',
      'SELECT_MUNICIPALITY',
    ]),

    async updateJurisdiction() {
      try {
        this.loading = true;
        await this.UPDATE_JURISDICTION(this.$route.params.id);
        this.loading = false;
      } catch (err) {
        console.error(err);
        ErrorService.onError(err);
        this.loading = false;
      }
    }
  }
};
</script>
